import script from "./IncomeStatementFund.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeStatementFund.vue?vue&type=script&setup=true&lang=js"

import "./IncomeStatementFund.vue?vue&type=style&index=0&id=13990d88&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13990d88"]])

export default __exports__